import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import CreativeMarket from './CreativeMarket.svg';
import CSSTricks from './CSSTricks.svg';
import Google from './Google.svg';
import HongKiat from './HongKiat.svg';
import Kinsta from './Kinsta.svg';
import Microsoft from './Microsoft.svg';
import MongoDB from './MongoDB.svg';
import ProductHunt from './ProductHunt.svg';
import Scotch from './Scotch.svg';
import SitePoint from './SitePoint.svg';
import SmashingMagazine from './SmashingMagazine.svg';
import TheDevCouple from './TheDevCouple.svg';
import TutsPlus from './TutsPlus.svg';
import WordPress from './WordPress.svg';
import WPEngine from './WPEngine.svg';

const Wrap = styled.div`
	display: table;
	width: 100%;
	padding: 5rem 0;
	position: relative;
	background: ${props => props.theme.w};

	&::before {
		content: '';
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		display: block;
		height: 1px;
		background: linear-gradient(
			to right,
			rgba(227, 231, 235, 0.1) 0px,
			rgba(227, 231, 235, 0.6) 50%,
			rgba(227, 231, 235, 0.1) 100%
		);
	}

	&::after {
		content: 'FEATURED & PUBLISHED';
		display: table;
		padding: 0 1rem;
		position: absolute;
		bottom: -10px;
		left: 50%;
		background: ${props => props.theme.gray1};
		transform: translate(-50%, 0);
		text-transform: uppercase;
		font-family: ${props => props.theme.f2};
		font-weight: 400;
		font-size: 1.3rem;
		color: rgba(63, 66, 83, 0.7);
		letter-spacing: 3px;
		text-align: center;
		z-index: 10;

		${rmq('t')} {
			font-size: 1.1rem;
		}
		${rmq('ml')} {
			font-size: 1rem;
		}
	}
`;

const Inner = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	max-width: 75rem;
	margin: 0 auto;
`;

const Logo = styled.span`
	display: flex;
	justify-content: center;

	.TutsPlus {
		height: 3rem;
	}
	.CSSTricks {
		height: 2.5rem;
		padding: 0.7rem;
	}
	.ProductHunt {
		max-height: 4rem;
	}

	.Scotch {
		height: 3rem;
		padding: 0.3rem 0.5rem;
	}

	${rmq('460')} {
		:last-child {
			padding: 2rem 3rem 0;
		}
	}

	${rmq('300')} {
		:last-child {
			padding: 0 3rem;
		}
	}
`;

const Img = styled.img`
	display: inline-block;
	width: 100%;
	height: auto;
	max-width: 15rem;
	max-height: 3.5rem;
	padding: 0.5rem;
	margin: 2rem auto;

	${rmq('ml')} {
		margin: 0.5rem auto;
	}
`;

const data = [
	{ name: 'SmashingMagazine', img: SmashingMagazine },
	{ name: 'Google', img: Google },
	{ name: 'MongoDB', img: MongoDB },
	{ name: 'Microsoft', img: Microsoft },
	{ name: 'CSSTricks', img: CSSTricks },
	{ name: 'SitePoint', img: SitePoint },
	{ name: 'HongKiat', img: HongKiat },
	{ name: 'CreativeMarket', img: CreativeMarket },
	{ name: 'ProductHunt', img: ProductHunt },
	{ name: 'WordPress', img: WordPress },
	{ name: 'WPEngine', img: WPEngine },
	{ name: 'Scotch', img: Scotch },
	{ name: 'TutsPlus', img: TutsPlus },
	{ name: 'TheDevCouple', img: TheDevCouple },
	{ name: 'Kinsta', img: Kinsta },
];

export default () => (
	<Wrap>
		<Inner>
			{data.map((item, i) => (
				<Logo key={i}>
					<span className="screen-reader-text">{item.name}</span>
					<Img
						className={`${item.name} lazyload`}
						loading="lazy"
						data-src={item.img}
						alt={item.name}
					/>
				</Logo>
			))}
		</Inner>
	</Wrap>
);
